import { useContext, useEffect, useRef, useState } from "react"
import { AppContext } from "../App"
import { MdChevronLeft, MdLogout, MdMenu, MdNotifications, MdOutlineMessage, MdOutlineNotifications } from "react-icons/md";
import { IoChevronBack, IoNotificationsOutline, IoRefreshCircleOutline } from "react-icons/io5";
import { TbMessageDots, TbNotification } from "react-icons/tb";
import { callApi, generateRandomString, getTopBarTitle, setCookie, WEB_SOCKET_URL } from "../Helpers";
import { AiOutlineNotification, AiOutlineUser, AiTwotoneNotification } from 'react-icons/ai';
import { BiSolidNotification } from "react-icons/bi";
import { RiMessage2Line } from "react-icons/ri";

export default function TopBar(props) {

  const appContext = useContext(AppContext);
  const [title, setTitle] = useState("");
  const [unreadInboxes, setUnreadInboxes] = useState(0);

  const inboxRefresherRef = useRef(null);

  const webSocketRef = useRef(null)
  const [ webSocketConnected, setWebSocketConnected ] = useState(2); //0 = not, 1=conn, 2= start
  const [ webSocketReconnectTimer, setWebSocketReconnectTimer ] = useState(null);
  const wsRandomId = generateRandomString();

  async function init() {
    if(appContext.currentUserData) {
      setupWebSocket();
    }
  }

  function setupWebSocket() {
    //subscribe for data from websocket server
    webSocketRef.current = new WebSocket(WEB_SOCKET_URL);
    webSocketRef.current.addEventListener('open', async () => {
      //send subscription message
      // using delay hack
      
      setTimeout(async () => {
        if(webSocketRef.current.readyState === WebSocket.OPEN) {

          //subscribe for game all inboxes
          webSocketRef.current.send(JSON.stringify({
            subscribeFor: 'all-inboxes',
            userId: appContext?.currentUserData?.id || "",
            userToken: appContext?.currentUserData?.token || "",
            sourceId: 'inboxList'+wsRandomId,
          }));

          
        }
      }, 3000);
      setWebSocketConnected(1);
        
      
    })

    webSocketRef.current.addEventListener('close', (e) => {
      if(!e.wasClean) {
        setWebSocketConnected(0);
        //try to reconnect after 5 seconds
        setWebSocketReconnectTimer((prevTimer) => {
          if(prevTimer) {
            clearInterval(prevTimer);
          }

          let timer = setInterval(() => {
            setupWebSocket();
          }, 5000);

          return timer;
        })
      }
    })

    webSocketRef.current.addEventListener('message', (e) => {
      const response = JSON.parse(e.data);
      console.log("Websocket response", response);

      if(response.subscribeFor === 'all-inboxes') {
        appContext.setUserInboxes(response.data);
      }
      
    })
  }

  function closeWebSocket() {
    //send unsubscribe req 
    if(webSocketRef.current && webSocketRef.current.readyState === WebSocket.OPEN) {
      webSocketRef.current.send(JSON.stringify({
        unsubscribeFor: 'all-inboxes',
        userId: appContext?.currentUserData?.id || "",
        userToken: appContext?.currentUserData?.token || "",
        sourceId: 'inboxList'+wsRandomId,
      }));

      
    }

    //then close connection
    if(webSocketRef.current) {
      webSocketRef.current.close();
    }

    //clear  reconnect timer
    if(webSocketReconnectTimer) {
      clearInterval(webSocketReconnectTimer);
    }
  }

  useEffect(() => {
    let _title = getTopBarTitle(appContext); 

    if(_title) {
      setTitle(_title);
    }
  }, [ appContext.navItem, appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

  useEffect(() => {
    if(appContext.userInboxes) {
      let _unread = 0;

      for (const _inbox of appContext.userInboxes) {
        if(_inbox.isLatestMessageRead === 'no' && Number(_inbox.fromId) !== Number(appContext.currentUserData.id)) {
          _unread++;
        }
      }

      setUnreadInboxes(_unread);
    }
  }, [ appContext.userInboxes ])

  useEffect(() => {
    //setup here
    init();

    return () => {
      closeWebSocket();
    }
  }, [ appContext.currentUserData ])

  return (
    <div
      className="TopBar mShadow3"
    >

      <div
        className="container d-flex"
        style={{
          height: "100%",
        }}
      >


        <div
          className="mTitle text-start mOneLineText flex-grow-1 d-flex"
        >
          {
            (
              (appContext.navItem !== 'home' && appContext.navItem) ||
              (appContext.navItem === 'home' && appContext.navSubItem)
            ) ?
            <MdChevronLeft
              className="align-self-center mNoMargin"
              size={38}
              
              onClick={appContext.navBack}
            />
            :""
          }
          <span
            className="align-self-center mNoMargin font-bold"
            style={{
              fontSize: "24px"
            }}
          >
            {title}
          </span>
        </div>



        <div
          className="mIcon text-end"
          onClick={() => {
            appContext.navTo({
              item: 'notifications',
            })
          }}
        >
          <IoNotificationsOutline
            className="mSymbol"
            
          />
          {
            (JSON.parse(appContext.currentUserData.newNotifications).length > 0) ?
            <span className="mBadge">{JSON.parse(appContext.currentUserData.newNotifications).length}</span>
            :""
          }
        </div>

        <div
          className="mIcon text-end"
          onClick={() => {
            appContext.navTo({
              item: 'inbox',
            })
          }}
        >
          <RiMessage2Line
            className="mSymbol"
            onClick={() => {
              appContext.navTo({
                item: 'inbox',
              })
            }}
          />
          {
            (Number(unreadInboxes) > 0) ?
            <span className="mBadge">{unreadInboxes}</span>
            :""
          }
        </div>

      </div>
    </div>
  )
}